module.exports = __webpack_public_path__ + "static/img/100821.fc00a735.png";